import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import { getUseFiscalYear } from 'reporting-data/lib/fiscalYearUtils';
import { getCompare, getReportConfig } from 'reporting-data/report/configReportGetters';
import { setCompare, setReportConfig, setUseFiscalYearInAggregation } from 'reporting-data/report/configReportSetters';
import BaseSelectComponent from '../../shared-components/BaseSelectComponent';
import { NO_COMPARE, getCompareOptionsForDropdown, getToolTipText } from './configReportComparisonUtils';

// @ts-expect-error Untyped import
import { isComparisonConfig } from 'reporting-data/compare';
// @ts-expect-error Untyped import
import { isMismatchedDimensionDateFilterPropertyTimeSeries } from 'reporting-data/properties/isMismatchedDimensionDateFilterPropertyTimeSeries';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigReportComparisonDropdown = props => {
  const {
    report,
    onChange,
    explicit
  } = props;
  const dropdownOptions = useMemo(() => {
    return getCompareOptionsForDropdown(report, {
      explicit
    });
  }, [report, explicit]);
  const comparisonValue = useMemo(() => {
    const isInvalidDateRangeAndDimension = isMismatchedDimensionDateFilterPropertyTimeSeries(report);
    if (isComparisonConfig(getReportConfig(report)) && isInvalidDateRangeAndDimension) {
      onChange(report.removeIn(['config', 'compare']));
      return NO_COMPARE;
    }
    return getCompare(getReportConfig(report)) || NO_COMPARE;
  }, [report, onChange]);
  const tooltipText = useMemo(() => {
    return getToolTipText(report);
  }, [report]);
  const onComparisonChange = useCallback(({
    target: {
      value
    }
  }) => {
    const dateRangeUseFiscalYear = getUseFiscalYear(getReportConfig(report));
    onChange(report.withMutations(mutatedReport => {
      if (value === NO_COMPARE) {
        mutatedReport.removeIn(['config', 'compare']);
      } else {
        setReportConfig(mutatedReport, setCompare(getReportConfig(mutatedReport), value));
      }
      setReportConfig(mutatedReport, setUseFiscalYearInAggregation(getReportConfig(mutatedReport), dateRangeUseFiscalYear));
    }));
  }, [report, onChange]);
  return /*#__PURE__*/_jsx(BaseSelectComponent, Object.assign({}, props, {
    formControlLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.comparison-dropdown.config.label"
    }),
    tooltipText: tooltipText,
    options: dropdownOptions,
    value: comparisonValue,
    disabled: !!tooltipText,
    onChange: onComparisonChange,
    useDefaultValueComponent: false
  }));
};
export default ConfigReportComparisonDropdown;